export const MenuCategories = {
  SYSTEM_SETTINGS: {
    INSTITUTIONAL: "institutional",
    OPERATIONAL: "operational",
  },
};
